import { render, staticRenderFns } from "./TextBookSelect.vue?vue&type=template&id=828d3e3e&scoped=true&"
import script from "./TextBookSelect.vue?vue&type=script&lang=js&"
export * from "./TextBookSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828d3e3e",
  null
  
)

export default component.exports